import { render, staticRenderFns } from "./no404.vue?vue&type=template&id=2c37af22&scoped=true"
import script from "./no404.vue?vue&type=script&lang=js"
export * from "./no404.vue?vue&type=script&lang=js"
import style0 from "./no404.vue?vue&type=style&index=0&id=2c37af22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37af22",
  null
  
)

export default component.exports